module.exports = __webpack_public_path__ + "assets/img/xnyz-icon.8dc83194.png";